import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ConfirmationService, SelectItem } from "primeng/api";
import { FlujoVentaPasoIntegracion } from "../../../../_models/flujo-venta-paso-integracion";
import { NavService } from "../../../../_services/_nav.service";
import { FlujoVentaPaso } from "../../../../_models/flujo-venta-paso";
import { ListaItem } from "../../../../_models/lista-item";
import { FlujoVentaPasoIntegracionService } from "../../../../_services/flujo-venta-paso-integracion.service";
import { FlujoVentaPasosIntegracionVinculacionService } from "../../../../_services/flujo-venta-pasos-integracion-vinculacion.service";
import { forkJoin } from "rxjs";
import { FlujoVentaPasosIntegracionVinculacion } from "../../../../_models/flujo-venta-paso-integracion-vinculacion";
import {
  FlujoVentaPasoIntegracionOcupacionService
} from "../../../../_services/flujo-venta-paso-integracion-ocupacion.service";
import {FlujoVentaPasosIntegracionesOcupaciones} from "../../../../_models/flujo-venta-pasos-integraciones-ocupaciones";

@Component({
  selector: "app-flujo-venta-integraciones",
  templateUrl: "./flujo-venta-integraciones.component.html",
  styleUrls: ["./flujo-venta-integraciones.component.css"],
})
export class FlujoVentaIntegracionesComponent implements OnInit {
  @Input() fluVentaPaso: FlujoVentaPaso;
  @Input() lisIntegraciones: ListaItem[] = [];
  @Input() listaVinculaciones: SelectItem[] = [];
  @Input() listasTiposOcupaciones: SelectItem[] = [];
  cargando = true;
  lisFlujoIntegracionesTodos: FlujoVentaPasoIntegracion[] = [];
  lisFlujoIntegraciones: FlujoVentaPasoIntegracion[] = [];
  lisflujoVentaPasosIntegracionVinculacion: FlujoVentaPasosIntegracionVinculacion[] = [];
  lisflujoVentaPasoIntegracionOcupacion: FlujoVentaPasosIntegracionesOcupaciones[] = [];
  formulario: FormGroup;
  submitted = false;
  columnas: any[] = [];
  lisIntegracionesSelect: SelectItem[] = [];
  invalidDependentFields = false;
  textoDetalle: string;
  detalle = false;
  tituloDetalle: string;
  editando = false;

  constructor(
    private fb: FormBuilder,
    private conService: ConfirmationService,
    private navService: NavService,
    private fluVentaPasoIntegracionService: FlujoVentaPasoIntegracionService,
    private flujoVentaPasosIntegracionVinculacionService: FlujoVentaPasosIntegracionVinculacionService,
    private flujoVentaPasoIntegracionOcupacionService: FlujoVentaPasoIntegracionOcupacionService
  ) {}

  ngOnInit() {
    this.columnas = [
      {
        field: "nombreListaIntegracion",
        header: this.navService.buscarMensaje(
          "FLUJOVENTACONSULTAS.LBL_CONSULTAS"
        ),
        sort: false,
      },
      {
        field: "codigoListaIntegracion",
        header: this.navService.buscarMensaje("FLUJOVENTACONSULTAS.LBL_CODIGO"),
        sort: false,
      },
      {
        field: "indicadorSolicitud",
        header: this.navService.buscarMensaje(
          "FLUJOVENTACONSULTAS.LBL_SOLICITUD"
        ),
        sort: false,
      },
      {
        field: "indicadorGestorTerceros",
        header: this.navService.buscarMensaje("FLUJOVENTACONSULTAS.LBL_GT"),
        sort: false,
      },
      {
        field: "flujoVentaPasosIntegracionVinculacionTextoCorto",
        header: this.navService.buscarMensaje(
          "FLUJOVENTACONSULTAS.LBL_VINCULACION"
        ),
        sort: false,
      },
      {
        field: "flujoVentaPasosIntegracionOcupacionesTextoCorto",
        header: this.navService.buscarMensaje(
          "FLUJOVENTACONSULTAS.LBL_OCUPACION"
        ),
        sort: false,
      },
      {
        field: "habilitado",
        header: this.navService.buscarMensaje(
          "FLUJOVENTACONSULTAS.LBL_HABILITADO"
        ),
        sort: false,
      },
      {
        field: "det",
        header: this.navService.buscarMensaje("LBL_ACCIONES"),
        sort: false,
      },
    ];
    this.cargaInicial();
  }

  cargaInicial() {
    forkJoin(
      this.fluVentaPasoIntegracionService.listadoPorIdFlujoVentaPaso(this.fluVentaPaso.idFlujoVentaPaso),
      this.flujoVentaPasosIntegracionVinculacionService.listado(),
      this.flujoVentaPasoIntegracionOcupacionService.enabled()
    ).subscribe(
      ([lisFlujoIntegraciones, lisflujoVentaPasosIntegracionVinculacion, lisflujoVentaPasoIntegracionOcupacion]) => {
        this.lisFlujoIntegracionesTodos = lisFlujoIntegraciones;
        this.lisflujoVentaPasosIntegracionVinculacion = lisflujoVentaPasosIntegracionVinculacion;
        this.lisflujoVentaPasoIntegracionOcupacion = lisflujoVentaPasoIntegracionOcupacion;
        this.cargarListado();
        this.cargarIntegraciones();
        this.cargarFormulario();
        this.cargando = false;
      }
    );
  }

  /* Cargar el listado de integraciones en el select */
  cargarIntegraciones() {
    this.lisIntegracionesSelect = [];
    this.lisIntegraciones.forEach((e) => {
      if (
        !this.lisFlujoIntegraciones.find(
          (x) => x.idListaIntegracion === e.idLista
        )
      ) {
        this.lisIntegracionesSelect.push({ label: e.nombre, value: e.idLista });
      }
    });
  }

  onSubmit() {
    this.submitted = true;
    console.log(this.formulario.value);
    if (
      this.f.indicadorSolicitud.value === false &&
      this.f.indicadorGestorTerceros.value === false
    ) {
      this.invalidDependentFields = true;
    } else {
      this.invalidDependentFields = false;
    }

    if (!this.formulario.valid) {
      return;
    }

    this.cargando = true;
    const registro = this.formulario.value;
    const existe = this.lisFlujoIntegracionesTodos.find(
      (x) => x.idListaIntegracion === registro.idListaIntegracion
    );
    if (existe) {
      existe.indicadorSolicitud = registro.indicadorSolicitud;
      existe.indicadorGestorTerceros = registro.indicadorGestorTerceros;
      existe.indicadorHabilitado = registro.indicadorHabilitado;
      existe.indicadorConsultaVinculacion = registro.indicadorConsultaVinculacion;
      existe.indicadorOcupacion = registro.indicadorOcupacion;
      this.fluVentaPasoIntegracionService.actualizar(existe).subscribe(async (r) => {
          if (r.indicadorConsultaVinculacion) {
            await this.bulkFlujoVentaPasosIntegracionVinculacion(r);
          }
          if (r.indicadorOcupacion) {
            await this.bulkFlujoVentaPasosIntegracionOcupacion(r);
          }
          this.salirGuardar();
      });
    } else if (!existe) {
      const integracion = this.lisIntegraciones.find(
        (x) => x.idLista === registro.idListaIntegracion
      );
      registro.nombreListaIntegracion = integracion ? integracion.nombre : null;
      registro.codigoListaIntegracion = integracion ? integracion.codigo : null;
      this.fluVentaPasoIntegracionService.crear(registro).subscribe(async (r) => {
          registro.idFlujoVentaPasoIntegracion = r.idFlujoVentaPasoIntegracion;
          this.lisFlujoIntegracionesTodos.push(registro);
          if (r.indicadorConsultaVinculacion) {
            await this.bulkFlujoVentaPasosIntegracionVinculacion(r);
          }
          if (r.indicadorOcupacion) {
            await this.bulkFlujoVentaPasosIntegracionOcupacion(r);
          }
          this.salirGuardar();
        });
    } else {
      this.navService.setMesage(0, {
        severity: "info",
        summary: this.navService.buscarMensaje("LBL_ATENCION"),
        detail: this.navService.buscarMensaje("MSG_YAEXISTEELREGISTRO"),
      });
      this.cargando = false;
    }
  }

  async bulkFlujoVentaPasosIntegracionOcupacion(data: FlujoVentaPasoIntegracion) {
    let registros: FlujoVentaPasosIntegracionesOcupaciones[] = [];
    this.f.idsOcupaciones.value.map((x) => {
      let flujoVentaPasosIntegracionesOcupaciones = {} as FlujoVentaPasosIntegracionesOcupaciones;
      const existe = this.lisflujoVentaPasoIntegracionOcupacion.find(
        (s) =>
          s.idFlujoVentaPasoIntegracion === data.idFlujoVentaPasoIntegracion &&
          s.idTipoOcupacion === x
      );
      if (existe) {
        flujoVentaPasosIntegracionesOcupaciones = existe;
        flujoVentaPasosIntegracionesOcupaciones.idFlujoVentaPasoIntegracion = flujoVentaPasosIntegracionesOcupaciones.idFlujoVentaPasoIntegracion ? flujoVentaPasosIntegracionesOcupaciones.idFlujoVentaPasoIntegracion : data.idFlujoVentaPasoIntegracion;
        flujoVentaPasosIntegracionesOcupaciones.indicadorHabilitado = true;
      } else {
        flujoVentaPasosIntegracionesOcupaciones.idFlujoVentaPasoIntegracion = data.idFlujoVentaPasoIntegracion;
        flujoVentaPasosIntegracionesOcupaciones.idTipoOcupacion = x;
        flujoVentaPasosIntegracionesOcupaciones.indicadorHabilitado = true;
      }
      registros.push(flujoVentaPasosIntegracionesOcupaciones);
    });
    this.lisflujoVentaPasoIntegracionOcupacion.filter(x => x.idFlujoVentaPasoIntegracion === data.idFlujoVentaPasoIntegracion).forEach(s => {
      const inhabilitar = registros.find(x => x.idTipoOcupacion === s.idTipoOcupacion);
      if (!inhabilitar) {
        s.indicadorHabilitado = false;
        registros.push(s);
      }
    });
    await this.flujoVentaPasoIntegracionOcupacionService.bulk(registros).toPromise();
  }

  /* guardar flujoventapasosintegracionesvinculaciones */
  async bulkFlujoVentaPasosIntegracionVinculacion(
    data: FlujoVentaPasoIntegracion
  ) {
    let registros: FlujoVentaPasosIntegracionVinculacion[] = [];
    this.f.idsVinculaciones.value.map((x) => {
      let flujoVentaPasosIntegracionVinculacion =
        {} as FlujoVentaPasosIntegracionVinculacion;
      const existe = this.lisflujoVentaPasosIntegracionVinculacion.find(
        (s) =>
          s.idFlujoVentaPasoIntegracion === data.idFlujoVentaPasoIntegracion &&
          s.idTipoVinculacion === x
      );
      if (existe) {
        flujoVentaPasosIntegracionVinculacion = existe;
        flujoVentaPasosIntegracionVinculacion.idFlujoVentaPasoIntegracion = flujoVentaPasosIntegracionVinculacion.idFlujoVentaPasoIntegracion
            ? flujoVentaPasosIntegracionVinculacion.idFlujoVentaPasoIntegracion
            : data.idFlujoVentaPasoIntegracion;
        flujoVentaPasosIntegracionVinculacion.indicadorHabilitado = true;
      } else {
        flujoVentaPasosIntegracionVinculacion.idFlujoVentaPasoIntegracion =
          data.idFlujoVentaPasoIntegracion;
        flujoVentaPasosIntegracionVinculacion.idTipoVinculacion = x;
        flujoVentaPasosIntegracionVinculacion.indicadorHabilitado = true;
      }
      registros.push(flujoVentaPasosIntegracionVinculacion);
    });
    await this.flujoVentaPasosIntegracionVinculacionService
      .bulk(registros)
      .toPromise();
  }

  salirGuardar() {
    this.navService.setMesage(1);
    this.submitted = false;
    this.editando = false;
    this.formulario.markAsPristine();
    this.cargaInicial();
  }

  /* controls del formulario */
  get f() {
    return this.formulario.controls;
  }

  cargarFormulario() {
    this.formulario = this.fb.group({
      idFlujoVentaPaso: [
        this.fluVentaPaso.idFlujoVentaPaso,
        [Validators.required],
      ],
      idListaIntegracion: [null, [Validators.required]],
      indicadorSolicitud: [false, [Validators.required]],
      indicadorGestorTerceros: [false, [Validators.required]],
      indicadorHabilitado: [false, [Validators.required]],
      idsVinculaciones: [null],
      idsOcupaciones: [null],
      indicadorConsultaVinculacion: [false, [Validators.required]],
      indicadorOcupacion: [false, [Validators.required]],
    });
  }

  /* configura el campo idsVinculaciones dependiendo del valor de indicadorConsultaVinculacion */
  consultaPorVinculacion() {
    if (this.f.indicadorConsultaVinculacion.value) {
      this.f.idsVinculaciones.setValidators(Validators.required);
    } else {
      this.f.idsVinculaciones.setValue(null);
      this.f.idsVinculaciones.setValidators(null);
      this.f.idsVinculaciones.updateValueAndValidity();
    }
  }

  /* Cargar listado de integraciones configuradas */
  cargarListado() {
    this.lisFlujoIntegraciones = this.lisFlujoIntegracionesTodos.filter(
      (x) => x.indicadorHabilitado
    );
    this.lisFlujoIntegraciones.map((x) => {
      x.flujoVentaPasosIntegracionVinculacion = [];
      x.flujoVentaPasosIntegracionOcupaciones = [];
      if (x.indicadorConsultaVinculacion) {
        let integracionVinculacion = "";
        this.lisflujoVentaPasosIntegracionVinculacion
          .filter(
            (e) =>
              e.idFlujoVentaPasoIntegracion === x.idFlujoVentaPasoIntegracion
          )
          .map((s) => {
            if (s.indicadorHabilitado) {
              x.flujoVentaPasosIntegracionVinculacion.push(s);
              if (integracionVinculacion) {
                integracionVinculacion = integracionVinculacion + ", " + s.tipoVinculacion;
              } else {
                integracionVinculacion = s.tipoVinculacion;
              }
            }
          });
        if (integracionVinculacion.length > 45) {
          x.flujoVentaPasosIntegracionVinculacionTextoCorto =
            integracionVinculacion.substring(0, 45);
          x.flujoVentaPasosIntegracionVinculacionTexto = integracionVinculacion;
          x.verCompletoflujoVentaPasosIntegracionVinculacion = true;
        } else {
          x.flujoVentaPasosIntegracionVinculacionTextoCorto =
            integracionVinculacion;
          x.flujoVentaPasosIntegracionVinculacionTexto = integracionVinculacion;
          x.verCompletoflujoVentaPasosIntegracionVinculacion = false;
        }
      }
      if (x.indicadorOcupacion) {
        let ocupaciones = "";
        this.lisflujoVentaPasoIntegracionOcupacion
          .filter(
            (e) =>
              e.idFlujoVentaPasoIntegracion === x.idFlujoVentaPasoIntegracion
          )
          .map((s) => {
            x.flujoVentaPasosIntegracionOcupaciones.push(s);
            if (ocupaciones) {
              ocupaciones = ocupaciones + ", " + s.tipoOcupacion;
            } else {
              ocupaciones = s.tipoOcupacion;
            }
          });
        if (ocupaciones.length > 45) {
          x.flujoVentaPasosIntegracionOcupacionesTextoCorto = ocupaciones.substring(0, 45);
          x.flujoVentaPasosIntegracionOcupacionesTexto = ocupaciones;
          x.verCompletoflujoVentaPasosOcupaciones = true;
        } else {
          x.flujoVentaPasosIntegracionOcupacionesTextoCorto = ocupaciones;
          x.flujoVentaPasosIntegracionOcupacionesTexto = ocupaciones;
          x.verCompletoflujoVentaPasosOcupaciones = false;
        }
      }
    });
  }

  /* Inabilitar la integracion */
  inhablitar(registro: FlujoVentaPasoIntegracion) {
    this.conService.confirm({
      message: this.navService.buscarMensaje("MSG_INHABILITAR"),
      header: this.navService.buscarMensaje("LBL_CONFIRMACION"),
      icon: "fa fa-question-circle",
      key: `flujoVentaIntegracion${this.fluVentaPaso.codigo}`,
      accept: () => {
        this.cargando = true;
        registro.indicadorHabilitado = false;
        this.fluVentaPasoIntegracionService
          .actualizar(registro)
          .subscribe((r) => {
            this.navService.setMesage(2);
            this.cargarListado();
            this.cargarIntegraciones();
            this.cargando = false;
          });
      },
    });
  }

  /* editar registro */
  editar(registro: FlujoVentaPasoIntegracion) {
    this.editando = true;
    this.cargando = true;
    this.lisIntegraciones.forEach((e) => {
      if (e.idLista === registro.idListaIntegracion) {
        this.lisIntegracionesSelect.push({ label: e.nombre, value: e.idLista });
      }
    });
    this.f.idFlujoVentaPaso.setValue(registro.idFlujoVentaPaso);
    this.f.idListaIntegracion.setValue(registro.idListaIntegracion);
    this.f.indicadorSolicitud.setValue(registro.indicadorSolicitud);
    this.f.indicadorGestorTerceros.setValue(registro.indicadorGestorTerceros);
    this.f.indicadorHabilitado.setValue(registro.indicadorHabilitado);
    this.f.indicadorConsultaVinculacion.setValue(registro.indicadorConsultaVinculacion);
    this.f.indicadorOcupacion.setValue(registro.indicadorOcupacion);
    let idsVinculaciones: string[] = [];
    if (registro.flujoVentaPasosIntegracionVinculacion) {
      registro.flujoVentaPasosIntegracionVinculacion.map((x) => {
        idsVinculaciones.push(x.idTipoVinculacion);
      });
      this.f.idsVinculaciones.setValue(idsVinculaciones);
    } else {
      this.f.idsVinculaciones.setValue(null);
    }
    if (registro.flujoVentaPasosIntegracionOcupaciones) {
      let idsOcupaciones: string[] = [];
      registro.flujoVentaPasosIntegracionOcupaciones.map((x) => {
        idsOcupaciones.push(x.idTipoOcupacion);
      });
      this.f.idsOcupaciones.setValue(idsOcupaciones);
    }
    this.validarOcupacionObligatorio(registro.indicadorOcupacion);
    this.cargando = false;
  }

  /* detalle tabla */
  detalleTabla(row: FlujoVentaPasoIntegracion) {
    this.tituloDetalle = this.navService.buscarMensaje(
      "FLUJOVENTACONSULTAS.LBL_VINCULACIONES"
    );
    this.textoDetalle = row.flujoVentaPasosIntegracionVinculacionTexto;
    this.detalle = true;
  }

  detalleTablaOcupaciones(row: FlujoVentaPasoIntegracion) {
    this.tituloDetalle = this.navService.buscarMensaje(
      "FLUJOVENTACONSULTAS.LBL_OCUPACION"
    );
    this.textoDetalle = row.flujoVentaPasosIntegracionOcupacionesTexto;
    this.detalle = true;
  }

  validarOcupacionObligatorio(event: boolean) {
    if (!event) {
      this.f.idsOcupaciones.setValue(null);
      this.f.idsOcupaciones.setValidators(null);
    } else {
      this.f.idsOcupaciones.setValidators(Validators.required);
    }
    this.f.idsOcupaciones.updateValueAndValidity();
  }
}
